import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class SpaceTypeService {

  constructor(private http: HttpClient) { }

  get(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.SPACETYPES, { params })
      .pipe(catchError(errorHandl));
  }

  getById(id: any) {
    return this.http.get(urls.API_URL + urls.SPACETYPES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  save(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.SPACETYPES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.SPACETYPES, payload)
        .pipe(catchError(errorHandl));
    }
  }
  getPicker(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.API_URL + urls.SPACETYPES + urls.PICKER, { params })
      .pipe(
        catchError(errorHandl)
      );
  }
}
